import React from 'react';

import { getMemoryType } from '../../helpers/memory';

import type { Memory } from '../../types/memory';

const MemoryType: React.FC<{ memory: Memory; style?: 'tag' | 'simple' }> = ({ memory, style = 'tag' }) => {
  return (
    <div className="memory-type">
      <div className="page-eyebrow">
        {memory.variant === 'sprk' ? (
          <>
            {style === 'tag' ? (
              <wa-tag className="sprk">
                <i className="fa-solid fa-bolt" />
                SPRK
              </wa-tag>
            ) : (
              <>
                <i className="fa-solid fa-bolt" />
                SPRK
              </>
            )}
          </>
        ) : (
          <>
            <i className={`fa-solid fa-${getMemoryType(memory.type)?.icon}`} />
            {getMemoryType(memory.type)?.label} - {memory.lgcy_type} LGCY
          </>
        )}
      </div>
    </div>
  );
}

export default MemoryType;
